import fetch from "cross-fetch";
import { ApiV1Base, ApiPrefix, statusCheck, json } from "../util/icwUtility";

export const WECHAT_LOGIN_BEGIN = "WECHAT_LOGIN_BEGIN";
export function actWechatLoginBegin() {
    return { type: WECHAT_LOGIN_BEGIN };
}

export const WECHAT_LOGIN_SUCCESS = "WECHAT_LOGIN_SUCCESS";
export function actWechatLoginSuccess(res) {
    return { type: WECHAT_LOGIN_SUCCESS, res };
}

export const WECHAT_LOGIN_FAIL = "WECHAT_LOGIN_FAIL";
export function actWechatLoginFail(reason) {
    return { type: WECHAT_LOGIN_FAIL, reason };
}

export function actWechatLogin(tokenObj) {
    return dispatch => {
        dispatch(actWechatLoginBegin());
        return fetch(`${ApiV1Base}${ApiPrefix}/wechat/wechatLogin`, {
            method: "post",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            body: JSON.stringify(tokenObj),
        })
            .then(statusCheck)
            .then(json)
            .then(json => {
                dispatch(actWechatLoginSuccess(json));
            })
            .catch(err => {
                dispatch(actWechatLoginFail(typeof err === "object" ? err.message : err));
            });
    };
}
